import * as yup from "yup";

import {
  Avatar,
  Button,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  List,
  ListItemIcon,
  MenuItem,
  Paper,
  Slide,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Menu,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { cyan, red } from "@mui/material/colors";
import {
  useAddNewCareerBreakMutation,
  useAddNewExperienceMutation,
  useDeleteCareerBreakMutation,
  useDeleteCvExperienceMutation,
  useEditCvExperienceMutation,
} from "../../../lib/cvsSlice";

import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import SaveIcon from "@mui/icons-material/Save";
import WorkIcon from "@mui/icons-material/Work";
import { careerBreakType } from "config";
import useFormPersist from "react-hook-form-persist";
import { yupResolver } from "@hookform/resolvers/yup";

const setMonthToNumber = (month) => {
  switch (month) {
    case "January":
      return 1;
    case "February":
      return 2;
    case "March":
      return 3;
    case "April":
      return 4;
    case "May":
      return 5;
    case "June":
      return 6;
    case "July":
      return 7;
    case "August":
      return 8;
    case "September":
      return 9;
    case "October":
      return 10;
    case "November":
      return 11;
    case "December":
      return 12;

    default:
      return "neutral";
  }
};

const experienceSchema = yup.object().shape({
  startMonth: yup.string().required("Month started is required"),
  startYear: yup.string().required("Year started is required"),
  endYear: yup.string().when("onGoing", {
    is: false,
    then: yup
      .string()
      .test(
        "endYear",
        "End year cannot be before start year",
        function (value, context) {
          var endYear = new Date(value);
          var specificEndYear = endYear.getFullYear();
          var specificStartYear = new Date(
            context.parent.startYear
          ).getFullYear();

          return specificEndYear >= specificStartYear;
        }
      ),
    notRequired: yup.boolean(),
  }),
  endMonth: yup.string().when(["onGoing", "startYear", "endYear"], {
    is: (onGoing) => !onGoing,
    then: yup
      .string()
      .test(
        "endMonth",
        "End month cannot be before start month",
        function (value, context) {
          var startMonth = context.parent.startMonth;
          var endMonth = value;
          var startYear = parseInt(context.parent.startYear);
          var endYear = parseInt(context.parent.endYear);

          if (startYear < endYear) {
            // If the start year is before the end year, don't apply the validation
            return true;
          } else if (startYear === endYear) {
            // If the start year is the same as the end year, compare the months
            const startMonthNum = setMonthToNumber(startMonth);
            const endMonthNum = setMonthToNumber(endMonth);
            return startMonthNum <= endMonthNum;
          } else {
            // Otherwise, end year is before the start year, validation fails
            return false;
          }
        }
      ),
    notRequired: yup.boolean(),
  }),
  role: yup.string().required("Role  is required"),
  companyName: yup.string().required("Company name is required"),
  type: yup.string(),
  location: yup.string(),
  description: yup.string(),
  excludeInCv: yup.boolean(),
  // duration : yup.string()
});

const careerBreakSchema = yup.object().shape({
  startMonth: yup.string().required("Month started is required"),
  startYear: yup.string().required("Year started is required"),
  endYear: yup.string().when("onGoing", {
    is: false,
    then: yup
      .string()
      .test(
        "endYear",
        "End year cannot be before start year",
        function (value, context) {
          var endYear = new Date(value);
          var specificEndYear = endYear.getFullYear();
          var specificStartYear = new Date(
            context.parent.startYear
          ).getFullYear();

          return specificEndYear >= specificStartYear;
        }
      ),
    notRequired: yup.boolean(),
  }),
  endMonth: yup.string().when(["onGoing", "startYear", "endYear"], {
    is: (onGoing) => !onGoing,
    then: yup
      .string()
      .test(
        "endMonth",
        "End month cannot be before start month",
        function (value, context) {
          var startMonth = context.parent.startMonth;
          var endMonth = value;
          var startYear = parseInt(context.parent.startYear);
          var endYear = parseInt(context.parent.endYear);

          if (startYear < endYear) {
            // If the start year is before the end year, don't apply the validation
            return true;
          } else if (startYear === endYear) {
            // If the start year is the same as the end year, compare the months
            const startMonthNum = setMonthToNumber(startMonth);
            const endMonthNum = setMonthToNumber(endMonth);
            return startMonthNum <= endMonthNum;
          } else {
            // Otherwise, end year is before the start year, validation fails
            return false;
          }
        }
      ),
    notRequired: yup.boolean(),
  }),
  type: yup.string().required("type is required"),
  location: yup.string(),
  description: yup.string().required("description is required"),
  onGoing: yup.boolean(),
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const WorkExperiences = ({ experiences, cvId }) => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("");
  const [workExperiences, setWorkExperiences] = useState(experiences);
  const [logStartYear, setLogStartYear] = useState();
  const [logEndYear, setLogEndYear] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [careerBreak, setCareerBreak] = useState([]);
  const [experienceId, setExperienceId] = useState();
  const [localExcludeInCv, setLocalExcludeInCv] = useState({});

  const [addNewExperience] = useAddNewExperienceMutation();
  const [deleteCvExperience] = useDeleteCvExperienceMutation();
  const [addNewCareerBreak] = useAddNewCareerBreakMutation();
  const [deleteCareerBreak] = useDeleteCareerBreakMutation();

  const handleOpen = (mode) => {
    setOpen(true);
    setMode(mode);
  };

  const handleClose = () => {
    reset();
    setOpen(false);
  };

  const handleCloseCareerBreak = () => {
    resetCareerBreakForm();
    setOpen(false);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Set the anchorEl to null to close the menu
  };

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    formState: { values, errors },
  } = useForm({
    resolver: yupResolver(experienceSchema),
    defaultValues: {
      companyName: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      role: "",
      excludeInCv: false,
    },
  });

  const {
    handleSubmit: handleCareerBreakSubmit,
    control: careerBreakControl,
    reset: resetCareerBreakForm,
    setValue: setCareerBreakValue,
    watch: watchCareerBreak,
    formState: { values: careerBreakValues, errors: careerBreakErrors },
  } = useForm({
    resolver: yupResolver(careerBreakSchema),
    defaultValues: {
      location: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      startMonth: "",
      type: "",
      onGoing: false,
      duration: "",
    },
  });

  const submitResults = async (e) => {
    const newExperience = e;

    // const { startYear, startMonth, endYear, endMonth } = e;
    // const duration = calculateDuration(startYear, startMonth, endYear, endMonth);//updating duration in the BE
    // newExperience.duration = `${duration.years} years and ${duration.months} months`;
    await addNewExperience({ cvId, experiencee: [newExperience] }).unwrap();
    setWorkExperiences(newExperience);
    console.log(experiences);
    experiences.push(newExperience);
    handleClose();
    toast.success("Experience added successfully");
  };

  const submitResultsCareerBreak = async (e) => {
    const newCareerBreak = e;
    const updatedCareerBreak = [...careerBreak, newCareerBreak];
    resetCareerBreakForm({
      endYear: "",
    });
    setLogStartYear(); // Set it to the initial value
    setLogEndYear(); // Set it to the initial value
    setCareerBreakValue("description", ""); // Set it to an empty string
    await addNewCareerBreak({ cvId, careerBreak: [newCareerBreak] }).unwrap();
    setCareerBreak(updatedCareerBreak);
    handleClose();
    toast.success("Career Break added successfully");
  };

  const handleRemove = async (item) => {
    await deleteCvExperience({ cvId, experienceeId: item }).unwrap();
    const updatedCvExperience = workExperiences.filter(
      (experience) => experience.id !== item
    );
    setWorkExperiences(updatedCvExperience);
    experiences.splice(
      experiences.findIndex((experience) => experience._id === item),
      1
    );
    setWorkExperiences([...experiences]);
    toast.info("Experience removed successfully");
  };

  const handleRemoveCareerBreak = async (cb) => {
    await deleteCareerBreak({ cvId, careerBreakId: cb }).unwrap();
    const updatedCareerBreak = careerBreak.filter(
      (careerbreak) => careerbreak.id !== cb
    );
    setCareerBreak(updatedCareerBreak);
    careerBreak.splice(
      careerBreak.findIndex((careerbreak) => careerbreak._id === cb),
      1
    );
    setCareerBreak([...careerBreak]);
    toast.info("Career Break removed successfully");
  };

  const [editCvExperience] = useEditCvExperienceMutation();
  const handleEdit = (experienceId, mode) => {
    setOpen(true);
    setMode(mode);
    setExperienceId(experienceId);
  };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const years = [];
  for (let year = 2023; year >= 1923; year--) {
    years.push(year);
  }

  useFormPersist("experiences", {
    watch,
    setValue,
    watchCareerBreak,
    setCareerBreakValue,
    storage: window.localStorage, // default window.sessionStorage
  });

  useEffect(() => {
    const data = localStorage.getItem(`experiences_${cvId}`);
    if (data !== null) JSON.parse(data);
  }, []);

  useEffect(() => {
    const data = localStorage.getItem(`careerBreak_${cvId}`);
    if (data !== null) setCareerBreak(JSON.parse(data));
  }, []);

  useEffect(() => {
    const initialLocalExcludeInCv = {};
    experiences.forEach((experience) => {
      const savedState = localStorage.getItem(`excludeInCv-${experience._id}`);
      initialLocalExcludeInCv[experience._id] = savedState === "true";
    });

    setLocalExcludeInCv(initialLocalExcludeInCv);
  }, [experiences]);

  useEffect(() => {
    localStorage.setItem(`experiences_${cvId}`, JSON.stringify(experiences));
    localStorage.setItem(`careerBreak_${cvId}`, JSON.stringify(careerBreak));
  }, [experiences, careerBreak, cvId]);

  // function calculateDuration(startYear, startMonth, endYear, endMonth) {
  //   const start = new Date(`${startMonth} 01, ${startYear}`);
  //   const end = new Date(`${endMonth} 01, ${endYear}`);

  //   const diff = end.getTime() - start.getTime();
  //   const yearInMs = 1000 * 60 * 60 * 24 * 365.25;
  //   const monthInMs = 1000 * 60 * 60 * 24 * 30.44;

  //   const years = Math.floor(diff / yearInMs);
  //   const months = Math.floor((diff % yearInMs) / monthInMs);

  //   return { years, months };
  // }

  const handleInputChange = (event, experienceId, fieldName) => {
    const experienceElement = experiences.find(
      (experience) => experience._id === experienceId
    );
    experienceElement[fieldName] = event.target.value;

    const updatedExperience = experiences.map((experience) => {
      if (experience._id === experienceId) {
        return { ...experience, [fieldName]: event.target.value };
      }
      return experience;
    });
    setWorkExperiences(updatedExperience);
  };

  const handleToggleChange = async (
    newExcludeInCv,
    experienceId,
    fieldName,
    updatedValue
  ) => {
    try {
      const updatedExperience = experiences.map((experience) => {
        if (experience._id === experienceId) {
          return {
            ...experience,
            [fieldName]: updatedValue,
          };
        }
        return experience;
      });
      setLocalExcludeInCv((prevLocalExcludeInCv) => ({
        ...prevLocalExcludeInCv,
        [experienceId]: newExcludeInCv,
      }));
      localStorage.setItem(
        `excludeInCv-${experienceId}`,
        newExcludeInCv.toString()
      );

      await editCvExperience({
        cvId: cvId,
        experienceId: experienceId,
        experience: updatedExperience.map((experience) => ({
          ...experience,
          excludeInCv: newExcludeInCv,
        })),
      });

      setWorkExperiences(updatedExperience);
    } catch (error) {
      console.error("Error updating toggle:", error);
    }
  };

  //Edit mode functionality
  const experienceElement = experiences.find((exp) => exp._id === experienceId);

  const renderSingleElement = () => {
    return (
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{ marginTop: "10px" }}
      >
        <Grid item xs={6}>
          <Controller
            name="startYear"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="Start year"
                fullWidth
                SelectProps={{
                  MenuProps: {
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "center",
                    },
                  },
                }}
                value={experienceElement.startYear}
                onChange={(e) =>
                  handleInputChange(e, experienceId, "startYear")
                }
                error={!!errors.startYear}
                helperText={errors?.startYear ? errors.startYear?.message : ""}
                logStartYear={logStartYear}
              >
                {years.map((year) => (
                  <MenuItem value={year} key={year}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            name="startMonth"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="Start month"
                fullWidth
                SelectProps={{
                  MenuProps: {
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "center",
                    },
                  },
                }}
                value={experienceElement.startMonth}
                onChange={(e) =>
                  handleInputChange(e, experienceId, "startMonth")
                }
                error={!!errors.startMonth}
                helperText={
                  errors?.startMonth ? errors.startMonth?.message : ""
                }
              >
                {monthNames.map((month) => (
                  <MenuItem value={month} key={month}>
                    {month}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>

        <Grid item xs={6}>
          <Controller
            name="endYear"
            control={control}
            rules={{ required: true }}
            render={({ field }) => {
              return (
                <TextField
                  {...field}
                  select
                  label="End year"
                  fullWidth
                  SelectProps={{
                    MenuProps: {
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                      },
                    },
                  }}
                  value={experienceElement.endYear}
                  onChange={(e) =>
                    handleInputChange(e, experienceId, "endYear")
                  }
                  logEndYear={logEndYear}
                  error={!!errors.endYear}
                  helperText={errors?.endYear ? errors.endYear?.message : ""}
                >
                  {years.map((year) => (
                    <MenuItem value={year} key={year}>
                      {year}
                    </MenuItem>
                  ))}
                </TextField>
              );
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Controller
            name="endMonth"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="End month"
                fullWidth
                SelectProps={{
                  MenuProps: {
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "center",
                    },
                  },
                }}
                value={experienceElement.endMonth}
                onChange={(e) => handleInputChange(e, experienceId, "endMonth")}
                error={!!errors.endMonth}
                helperText={errors?.endMonth ? errors.endMonth?.message : ""}
              >
                {monthNames.map((month) => (
                  <MenuItem value={month} key={month}>
                    {month}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="companyName"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Company Name"
                multiline
                maxRows={6}
                fullWidth
                value={experienceElement.companyName}
                onChange={(e) =>
                  handleInputChange(e, experienceId, "companyName")
                }
                error={!!errors.companyName}
                helperText={
                  errors?.companyName ? errors.companyName?.message : ""
                }
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Controller
            name="role"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Role"
                multiline
                maxRows={6}
                fullWidth
                value={experienceElement.role}
                onChange={(e) => handleInputChange(e, experienceId, "role")}
                error={!!errors.role}
                helperText={errors?.role ? errors.role?.message : ""}
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Role"
            fullWidth
            value={experienceElement.role}
            onChange={(e) => handleInputChange(e, experienceId, "role")}
          />
        </Grid>
      </Grid>
    );
  };

  const submitEditResults = async () => {
    await editCvExperience({
      cvId,
      experienceId,
      experience: [experienceElement],
    }).unwrap();
    handleClose();
    toast.info("Experiences updated successfully");
  };

  return (
    <div id="experiences">
      <ToastContainer autoClose={1500} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ marginTop: "20px", padding: "15px" }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
              sx={{ marginTop: "5px" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={2}
                  // justifyContent="center"
                  // alignItems="center"
                >
                  <Grid item xs={9}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      component="div"
                      sx={{ p: 2, pb: 0 }}
                    >
                      Work Experiences &nbsp;
                      <Tooltip
                        disableFocusListener
                        disableTouchListener
                        title="This section is mandatory"
                      >
                        <span style={{ color: "red" }}>*</span>
                      </Tooltip>
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <IconButton
                      aria-label="add"
                      onClick={(e) => handleMenuOpen(e)}
                    >
                      <AddIcon color="primary" />
                    </IconButton>
                    <Menu
                      id="add-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                      sx={{ zIndex: 2000 }}
                      disableScrollLock
                    >
                      <MenuItem onClick={() => handleOpen("add-experience")}>
                        <ListItemIcon>
                          <WorkIcon />
                        </ListItemIcon>
                        <ListItemText primary="Add new experience" />
                      </MenuItem>
                      <MenuItem onClick={() => handleOpen("add-break")}>
                        <ListItemIcon>
                          <PauseIcon />
                        </ListItemIcon>
                        <ListItemText primary="Add career break" />
                      </MenuItem>
                    </Menu>
                  </Grid>

                  <Grid item xs={1}>
                    <IconButton
                      aria-label="edit"
                      onClick={() => handleOpen("edit")}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {experiences?.map((experience) => (
                  <List key={experience?._id} sx={{ padding: "0px" }}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar sx={{ backgroundColor: cyan[700] }}>
                          <LocalLibraryOutlinedIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        sx={{ paddingLeft: "10px" }}
                        primary={
                          <Typography variant="subtitle2" component="div">
                            Company: {experience?.companyName}
                          </Typography>
                        }
                        secondary={
                          <div>
                            <Typography variant="caption" display="block">
                              Start Date : {experience?.endMonth}{" "}
                              {experience?.startYear}
                            </Typography>
                            <Typography variant="caption" display="block">
                              End Date : {experience?.endMonth}{" "}
                              {experience?.endYear}
                            </Typography>
                            <Typography variant="caption" display="block">
                              Role : {experience?.role}
                            </Typography>
                            <Typography variant="caption" display="block">
                              Company Name : {experience?.companyName}
                            </Typography>
                            <Typography variant="caption" display="block">
                              Exclude in cv:{" "}
                              {experience.excludeInCv ? "Yes" : "No"}
                            </Typography>
                            {/* <Typography variant="subtitle2" component="div">
                            Duration: {experience?.duration}
                          </Typography> */}
                          </div>
                        }
                      />

                      <Grid
                        item
                        xs={12}
                        sm={3}
                        sx={{ textAlign: "right", paddingRight: "40px" }}
                      >
                        <FormControl>
                          <FormHelperText error={!!errors.excludeInCv}>
                            {errors?.excludeInCv
                              ? errors.excludeInCv?.message
                              : ""}
                          </FormHelperText>
                          <Controller
                            key={experience._id}
                            name={`excludeInCv-${experience._id}`}
                            control={control}
                            render={({
                              field: { onChange, value, ...field },
                            }) => (
                              <Tooltip title="This will exclude the section from the CV">
                                <FormControlLabel
                                  sx={{ margin: "0px" }}
                                  control={
                                    <Switch
                                      onChange={(e) => {
                                        const newExcludeInCv = e.target.checked;

                                        // Update the local state for the specific certificate immediately
                                        setLocalExcludeInCv(
                                          (prevLocalExcludeInCv) => ({
                                            ...prevLocalExcludeInCv,
                                            [experience._id]: newExcludeInCv,
                                          })
                                        );

                                        handleToggleChange(
                                          newExcludeInCv,
                                          experience._id,
                                          "excludeInCv"
                                        );

                                        console.log(
                                          "Toggle updated successfully"
                                        );
                                      }}
                                      checked={
                                        localExcludeInCv[experience._id] ||
                                        false
                                      }
                                      {...field}
                                      ref={null}
                                    />
                                  }
                                />
                              </Tooltip>
                            )}
                          />
                        </FormControl>
                      </Grid>
                    </ListItem>
                  </List>
                ))}
              </Grid>

              <Grid item xs={12}>
                {careerBreak?.map((cb) => (
                  <List key={cb?._id} sx={{ padding: "0px" }}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar sx={{ backgroundColor: cyan[700] }}>
                          <LocalLibraryOutlinedIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        sx={{ paddingLeft: "10px" }}
                        primary={
                          <Typography variant="subtitle2" component="div">
                            Career Break: {cb?.type}
                          </Typography>
                        }
                        secondary={
                          <div>
                            <Typography variant="caption" display="block">
                              Start Date : {cb?.startMonth} {cb?.startYear}
                            </Typography>
                            <Typography variant="caption" display="block">
                              End Date : {cb?.endMonth} {cb?.endYear}
                            </Typography>
                            <Typography variant="caption" display="block">
                              Location: {cb?.location}
                            </Typography>
                            <Typography variant="caption" display="block">
                              Done: {cb.onGoing ? "No" : "Yes"}
                            </Typography>
                            <Typography variant="caption" display="block">
                              Description: {cb?.description}
                            </Typography>
                          </div>
                        }
                      />
                    </ListItem>
                  </List>
                ))}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        disableEnforceFocus
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {mode === "add-experience" && (
          <form autoComplete="off" onSubmit={handleSubmit(submitResults)}>
            <DialogTitle>Add Work Experience</DialogTitle>
            <DialogContent dividers={true}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                sx={{ marginTop: "10px" }}
              >
                <Grid item xs={6}>
                  <Controller
                    name="startYear"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        select
                        label="Start year"
                        fullWidth
                        SelectProps={{
                          MenuProps: {
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "center",
                            },
                          },
                        }}
                        error={!!errors.startYear}
                        helperText={
                          errors?.startYear ? errors.startYear?.message : ""
                        }
                        logStartYear={logStartYear}
                        value={values?.startYear} // Update value prop
                        onChange={(e) => {
                          setLogStartYear(e.target.value);
                          field.onChange(e);
                        }}
                      >
                        {years.map((year) => (
                          <MenuItem value={year} key={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    name="startMonth"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        select
                        label="Start month"
                        fullWidth
                        SelectProps={{
                          MenuProps: {
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "center",
                            },
                          },
                        }}
                        error={!!errors.startMonth}
                        helperText={
                          errors?.startMonth ? errors.startMonth?.message : ""
                        }
                      >
                        {monthNames.map((month) => (
                          <MenuItem value={month} key={month}>
                            {month}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    name="endYear"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => {
                      const filteredYears = years.filter(
                        (year) => year >= logStartYear
                      );
                      return (
                        <TextField
                          {...field}
                          select
                          label="End year"
                          fullWidth
                          SelectProps={{
                            MenuProps: {
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "center",
                              },
                            },
                          }}
                          logEndYear={logEndYear}
                          error={!!errors.endYear}
                          helperText={
                            errors?.endYear ? errors.endYear?.message : ""
                          }
                          value={values?.endYear} // Update value prop
                          onChange={(e) => {
                            setLogEndYear(e.target.value);
                            field.onChange(e);
                          }}
                        >
                          {filteredYears.map((year) => (
                            <MenuItem value={year} key={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </TextField>
                      );
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    name="endMonth"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        select
                        label="End month"
                        fullWidth
                        SelectProps={{
                          MenuProps: {
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "center",
                            },
                          },
                        }}
                        error={!!errors.endMonth}
                        helperText={
                          errors?.endMonth ? errors.endMonth?.message : ""
                        }
                      >
                        {monthNames.map((month) => (
                          <MenuItem value={month} key={month}>
                            {month}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    name="companyName"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Company Name"
                        multiline
                        maxRows={6}
                        fullWidth
                        error={!!errors.companyName}
                        helperText={
                          errors?.companyName ? errors.companyName?.message : ""
                        }
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    name="role"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Role"
                        multiline
                        maxRows={6}
                        fullWidth
                        error={!!errors.role}
                        helperText={errors?.role ? errors.role?.message : ""}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                sx={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}

        {mode === "add-break" && (
          <form
            autoComplete="off"
            onSubmit={handleCareerBreakSubmit(submitResultsCareerBreak)}
          >
            <DialogTitle>Add Career Break</DialogTitle>
            <DialogContent dividers={true}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                sx={{ marginTop: "10px" }}
              >
                <Grid item xs={12}>
                  <Controller
                    name="type"
                    control={careerBreakControl}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Type"
                        select
                        fullWidth
                        error={!!careerBreakErrors.type}
                        SelectProps={{
                          MenuProps: {
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "center",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "center",
                            },
                          },
                        }}
                        helperText={
                          careerBreakErrors?.type
                            ? careerBreakErrors.type?.message
                            : ""
                        }
                      >
                        {careerBreakType.map((type) => (
                          <MenuItem value={type} key={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    name="location"
                    control={careerBreakControl}
                    defaultValue="Ex: London, United Kingdom"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Location"
                        fullWidth
                        error={!!careerBreakErrors.location}
                        helperText={
                          careerBreakErrors?.location
                            ? careerBreakErrors.location?.message
                            : ""
                        }
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl>
                    <FormHelperText error={!!careerBreakErrors.onGoing}>
                      {careerBreakErrors?.onGoing
                        ? careerBreakErrors.onGoing?.message
                        : ""}
                    </FormHelperText>
                    <Controller
                      name="onGoing"
                      control={careerBreakControl}
                      rules={{ required: true }}
                      //  onSubmit={() => {}}
                      render={({ field: { onChange, value, ...field } }) => (
                        <FormControlLabel
                          label="On Going"
                          sx={{ margin: "0px" }}
                          control={
                            <Checkbox
                              onChange={onChange}
                              checked={value}
                              {...field}
                              ref={null}
                            />
                          }
                        />
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    name="startYear"
                    control={careerBreakControl}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        select
                        label="Start year"
                        fullWidth
                        SelectProps={{
                          MenuProps: {
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "center",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "center",
                            },
                          },
                        }}
                        error={!!careerBreakErrors.startYear}
                        helperText={
                          careerBreakErrors?.startYear
                            ? careerBreakErrors.startYear?.message
                            : ""
                        }
                        logStartYear={logStartYear}
                        value={careerBreakValues?.startYear} // Update value prop
                        onChange={(e) => {
                          setLogStartYear(e.target.value);
                          field.onChange(e);
                        }}
                      >
                        {years.map((year) => (
                          <MenuItem value={year} key={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    name="startMonth"
                    control={careerBreakControl}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        select
                        label="Start month"
                        fullWidth
                        SelectProps={{
                          MenuProps: {
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "center",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "center",
                            },
                          },
                        }}
                        error={!!careerBreakErrors.startMonth}
                        helperText={
                          careerBreakErrors?.startMonth
                            ? careerBreakErrors.startMonth?.message
                            : ""
                        }
                      >
                        {monthNames.map((month) => (
                          <MenuItem value={month} key={month}>
                            {month}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </Grid>

                {!watchCareerBreak("onGoing") && (
                  <>
                    <Grid item xs={6}>
                      <Controller
                        name="endYear"
                        control={careerBreakControl}
                        rules={{ required: true }}
                        render={({ field }) => {
                          const filteredYears = years.filter(
                            (year) => year >= logStartYear
                          );
                          return (
                            <TextField
                              {...field}
                              select
                              label="End year"
                              fullWidth
                              SelectProps={{
                                MenuProps: {
                                  anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "center",
                                  },
                                  transformOrigin: {
                                    vertical: "top",
                                    horizontal: "center",
                                  },
                                },
                              }}
                              logEndYear={logEndYear}
                              error={!!careerBreakErrors.endYear}
                              helperText={
                                careerBreakErrors?.endYear
                                  ? careerBreakErrors.endYear?.message
                                  : ""
                              }
                              value={careerBreakValues?.endYear}
                              onChange={(e) => {
                                setLogEndYear(e.target.value);
                                field.onChange(e);
                              }}
                            >
                              {filteredYears.map((year) => (
                                <MenuItem value={year} key={year}>
                                  {year}
                                </MenuItem>
                              ))}
                            </TextField>
                          );
                        }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <Controller
                        name="endMonth"
                        control={careerBreakControl}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            select
                            label="End month"
                            fullWidth
                            SelectProps={{
                              MenuProps: {
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "center",
                                },
                                transformOrigin: {
                                  vertical: "top",
                                  horizontal: "center",
                                },
                              },
                            }}
                            error={!!careerBreakErrors.endMonth}
                            helperText={
                              careerBreakErrors?.endMonth
                                ? careerBreakErrors.endMonth?.message
                                : ""
                            }
                          >
                            {monthNames.map((month) => (
                              <MenuItem value={month} key={month}>
                                {month}
                              </MenuItem>
                            ))}
                          </TextField>
                        )}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={careerBreakControl}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label="Description"
                        multiline
                        rows={4}
                        fullWidth
                        error={!!careerBreakErrors.description}
                        helperText={
                          careerBreakErrors?.role
                            ? careerBreakErrors.description?.message
                            : ""
                        }
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                sx={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleCloseCareerBreak}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}

        {mode === "edit" && (
          <form>
            <DialogTitle>Edit/Remove Experience</DialogTitle>
            <DialogContent dividers={true}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{ marginTop: "5px" }}
              >
                <Grid item xs={12}>
                  {experiences?.map((experience) => (
                    <List key={experience._id} sx={{ padding: "0px" }}>
                      <ListItem
                        sx={{ paddingLeft: "10px" }}
                        secondaryAction={
                          <Stack
                            display="flex"
                            justifyContent="flex-end"
                            direction="row"
                            paddingBottom="80px"
                          >
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                handleEdit(experience._id, "editnew")
                              }
                            >
                              <EditIcon color="primary" />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleRemove(experience._id)}
                            >
                              <DeleteIcon sx={{ color: red[400] }} />
                            </IconButton>
                          </Stack>
                        }
                      >
                        <ListItemText
                          sx={{ paddingRight: "20px", margin: "0px" }}
                          primary={
                            <Typography variant="subtitle2" component="div">
                              Company: {experience?.companyName}
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography variant="caption" display="block">
                                Start Date : {experience?.startMonth}{" "}
                                {experience?.startYear}
                              </Typography>
                              <Typography variant="caption" display="block">
                                End Date: {experience?.endMonth}{" "}
                                {experience?.endYear}
                              </Typography>
                              <Typography variant="caption" display="block">
                                Role: {experience?.role}
                              </Typography>
                              <Typography variant="caption" display="block">
                                Company Name: {experience?.companyName}
                              </Typography>
                              <Typography variant="caption" display="block">
                                Exclude in cv:{" "}
                                {experience.excludeInCv ? "Yes" : "No"}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                    </List>
                  ))}
                </Grid>

                <Grid item xs={12}>
                  {careerBreak?.map((cb) => (
                    <List key={cb._id} sx={{ padding: "0px" }}>
                      <ListItem
                        sx={{ paddingLeft: "10px" }}
                        secondaryAction={
                          <Stack alignItems="right" direction="row">
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleEdit(cb._id)}
                            >
                              <EditIcon color="primary" />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleRemoveCareerBreak(cb._id)}
                            >
                              <DeleteIcon sx={{ color: red[400] }} />
                            </IconButton>
                          </Stack>
                        }
                      >
                        <ListItemText
                          sx={{ paddingRight: "20px", margin: "0px" }}
                          primary={
                            <Typography variant="subtitle2" component="div">
                              Career Break: {cb?.type}
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography variant="caption" component="div">
                                Start Date: {cb?.startMonth} {cb?.startYear}
                              </Typography>
                              <Typography variant="caption" display="block">
                                End Date: {cb?.endMonth} {cb?.endYear}
                              </Typography>
                              <Typography variant="caption" display="block">
                                Location: {cb?.location}
                              </Typography>
                              <Typography variant="caption" display="block">
                                Description: {cb?.description}
                              </Typography>
                              <Typography variant="caption" display="block">
                                Done: {cb.onGoing ? "No" : "Yes"}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                    </List>
                  ))}
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                sx={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                      disabled
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}

        {mode === "editnew" && (
          <form
            autoComplete="off"
            onSubmit={() => {
              submitEditResults();
            }}
          >
            <DialogTitle>Edit Work Experiences</DialogTitle>
            <DialogContent dividers={true}>
              {renderSingleElement()}
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={2}
                sx={{ margin: "10px" }}
                justifyContent="flex-end"
              >
                <Grid item xs={12}>
                  <Stack alignItems="right" direction="row" spacing={3}>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<SaveIcon />}
                      type="submit"
                    >
                      Save
                    </Button>
                    <Button
                      sx={{ borderRadius: 10 }}
                      variant="contained"
                      startIcon={<CancelIcon />}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}
      </Dialog>
    </div>
  );
};

export default WorkExperiences;